import { useCallback, useEffect, useState } from 'react'
import {
    CommissionOrderImport,
    ImportCommissionOrdersReturn,
    PartSearchInfo,
    fetchParts,
} from '../../../features/order/orderAPI'
import _ from 'lodash'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { getSpecificPartInfo } from '../../../FastQuote/Components/LineItems'
import { FastQuoteInput } from '../../../GlobalComponents/Inputs/Inputs'

interface ImportPartNumberProps {
    partNumber: string
    accountCode: string
    rowNumber: number
    commissionsInput: CommissionOrderImport
    chosenCommissionOrder: ImportCommissionOrdersReturn
    OnChosenCommissionOrderChange: (dataItem: any) => void
    OnCorrectionMade: (dataItem: any) => void
}

export const ImportPartNumberTextBox = (props: ImportPartNumberProps) => {
    const {
        partNumber,
        accountCode,
        rowNumber,
        chosenCommissionOrder,
        OnChosenCommissionOrderChange,
        commissionsInput,
        OnCorrectionMade,
    } = props

    const [loading, setLoading] = useState(false)

    const [value, setValue] = useState<string | null>(partNumber || '')
    const [inputValue, setInputValue] = useState('')

    const [parts, setParts] = useState<Array<PartSearchInfo>>([])

    const getParts = useCallback(
        _.debounce(
            async (search: string, controller: AbortController) => {
                setLoading(true)
                setParts([])
                let parts = await fetchParts(
                    { searchValue: search, accountCode: accountCode },
                    controller
                )
                if (parts) {
                    setParts(parts.d)
                }
                setLoading(false)
            },
            500,
            { trailing: true }
        ),
        []
    )

    useEffect(() => {
        if (inputValue) {
            const controller = new AbortController()

            getParts(inputValue, controller)

            return () => {
                controller.abort()
            }
        }
    }, [inputValue])

    return (
        <Autocomplete
            freeSolo
            options={parts.filter((data: PartSearchInfo) => data.Source !== 'ProductCount')}
            getOptionLabel={(option) => option.Name || option || ''}
            value={value}
            defaultValue={partNumber}
            loading={loading}
            onChange={async (event: any, value: any) => {
                if (!value) return

                let partNumber = value.toUpperCase()

                setInputValue(partNumber)

                // when an option is selected
                if (typeof value !== 'string') {
                    let info = await getSpecificPartInfo(partNumber, accountCode)
                    partNumber = info.PartInfo.PartNumber
                }

                const tempItems = chosenCommissionOrder?.Order.LineItems.map((line) => {
                    if (line.Row === rowNumber) line.LineItem.PartNumber = partNumber

                    return line
                })
                OnChosenCommissionOrderChange({
                    ...chosenCommissionOrder!,
                    Order: {
                        ...chosenCommissionOrder!.Order,
                        LineItems: tempItems!,
                    },
                })

                const updatedItem = commissionsInput!.CommissionOrderItems.find(
                    (line) => line.Row.Value === rowNumber
                )

                if (updatedItem) {
                    updatedItem.PartNumber.Value = partNumber
                    OnCorrectionMade({
                        ...commissionsInput!,
                        CommissionOrderItems: [updatedItem],
                    })
                }
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue)
            }}
            id='controllable-states-demo'
            filterOptions={(options, state) => {
                return options
            }}
            renderOption={(option, state) => {
                let divs = [...option.Markup.matchAll(/<div>(.*?)<\/div>/g)]

                return (
                    <div>
                        <div style={{ fontWeight: 500, fontSize: 12 }}>{divs[0][1]}</div>
                        {divs[1] && <div style={{ fontSize: 10 }}>{divs[1][1]}</div>}
                    </div>
                )
            }}
            renderInput={(params) => <FastQuoteInput {...params} />}
        />
    )
}
